module.exports = __webpack_public_path__ + "img/logo-fr.5edde18483738604cba61de980780d17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-fr.svg
// module id = 707
// module chunks = 0